import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
export class HoldingsService extends BaseService {
  burgissHoldingCalcTotalInvested(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateCurrrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.TotalInvested,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateCurrrency
      );
      return super._pushOperation(
        "burgissHoldingCalcTotalInvested",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.TotalInvested,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateCurrrency
      );
      return super._pushOperation(
        "burgissHoldingCalcTotalInvested",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.TotalInvested,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateCurrrency
      );
      return super._pushOperation(
        "burgissHoldingCalcTotalInvested",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }
  BurgissHoldingCalcCostBasis(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.CostBasis,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcCostBasis",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.CostBasis,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcCostBasis",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.CostBasis,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcCostBasis",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcReturnOfCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.ReturnOfCapital,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcReturnOfCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.ReturnOfCapital,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcReturnOfCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.ReturnOfCapital,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcReturnOfCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcProceeds(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Proceeds,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcProceeds",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Proceeds,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcProceeds",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        false,
        beginDate,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Proceeds,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcProceeds",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcValuation(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Valuation,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcValuation",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Valuation,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcValuation",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Valuation,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcValuation",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcValuationDate(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Valuation,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcValuationDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Valuation,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcValuationDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.Valuation,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcValuationDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcDPI(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.DPI,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcDPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.DPI,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcDPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.DPI,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcDPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcRVPI(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.RVPI,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcRVPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.RVPI,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcRVPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.RVPI,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcRVPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }

  BurgissHoldingCalcTVPI(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.TVPI,
        investid,
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcTVPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.TVPI,
        [],
        [],
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcTVPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        endDate,
        currency,
        rollForward,
        null,
        idType,
        selectionSetId,
        filter,
        MeasuresType.TVPI,
        [],
        investid,
        excludeBalanceSheetItems,
        excludeUndisclosedItems,
        excludeUnknownEntities,
        excludRealizationspriorclosingdt,
        alternateBaseCurrency
      );
      return super._pushOperation(
        "BurgissHoldingCalcTVPI",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Holdings
      );
    }
    return null;
  }
  createPayload(
    alias: string = null,
    investId: any[][] = null,
    endDate: any = null,
    currency: string = null,
    rollForward: boolean = null,
    beginDate: any = null,
    idType: string = null,
    selectionSetId: any = null,
    filter: any = "",
    measure: string = null,
    portfolioId: any[][] = null,
    assetId: any[][] = null,
    excludeBalanceSheetItems: any = null,
    excludeUndisclosedItems: any = null,
    excludeUnknownEntities: any = null,
    excludeRealizationsPriorToClosingDate: any = null,
    alternateBaseCurrency: any = null
  ) {
    const holdingObject: Measures = {
      excludeBalanceSheetItems: excludeBalanceSheetItems,
      excludeUndisclosedItems: excludeUndisclosedItems,
      excludeUnknownEntities: excludeUnknownEntities,
      excludeRealizationsPriorToClosingDate: excludeRealizationsPriorToClosingDate,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: true,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: alternateBaseCurrency,
      adjustToMostRecent: rollForward != null ? Boolean(rollForward) : false,
      measure: measure,
      beginDate: beginDate,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: idType,
      selectionsetID: selectionSetId,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      weightingMethod: null,
      value: null,
      filter: filter,
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return holdingObject;
  }
}
